import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { filter, Subject, Subscription, takeUntil } from 'rxjs';
import { ChatServices } from '@app/services/chat.service';
import { WebSocketService } from '@app/services/webSocket.service';
import { QUANGULAR_CONFIG, QuangularConfig, UsersService } from 'quangular';
import { CurrentUserStateService } from '@app/services/currentUserState.service';
import { IUser } from '@common/models/IUser';
import { MsalService, MsalBroadcastService } from '@azure/msal-angular';
import { EventType, InteractionStatus } from '@azure/msal-browser';
import { Router } from '@angular/router';
import { SettingsMenuComponent } from './modules/settings/settings-menu/settings-menu.component';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
    title = 'Quantum IQ';
    @ViewChild('settingsMenu') settingsMenuComponent?: SettingsMenuComponent;
    getUserSub: Subscription = new Subscription();
    private destroy$ = new Subject<void>();
    loading = true;
    public readonly options = new Array(100).fill(0).map((_, i) => `Option ${i + 1}`);
    

    constructor(
        private chatService: ChatServices,
        private webSocketService: WebSocketService,
        @Inject(QUANGULAR_CONFIG) private config: QuangularConfig,
        private readonly currentUserStateService: CurrentUserStateService,
        private authService: MsalService,
        private usersService: UsersService,
        private msalBroadcastService: MsalBroadcastService, private router: Router) { }
    async ngOnInit(): Promise<void> {

        this.msalBroadcastService.inProgress$.pipe(
            filter((status: InteractionStatus) => status === InteractionStatus.None)).subscribe(async () => {
                const accounts = this.authService.instance.getAllAccounts();
                if (accounts?.length === 0) {
                    console.log('No accounts found, redirecting to login', Date.now());
                    this.authService.loginRedirect();
                } else {
                    this.authService.instance.setActiveAccount(accounts[0]);
                    await this.getUser();
                    this.loading = false
                }
            })

        // Workaround to handle infinite reload issue on login failure
        // https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/events.md#table-of-events
        this.msalBroadcastService.msalSubject$.subscribe({
            next: (msalService) => {
                const msalErrorEvents: EventType[] = [
                    EventType.ACQUIRE_TOKEN_BY_CODE_FAILURE,
                    EventType.ACQUIRE_TOKEN_FAILURE,
                    EventType.LOGIN_FAILURE
                ];
                const capturedEvent = msalService.eventType;
                if (msalErrorEvents.includes(capturedEvent)) {
                    console.log("Failure in Login with Event: ", capturedEvent);
                }
            }
        })
    }
    public environment(): any {
        return this.config.environment;
    }
    async getUser(): Promise<void> {
        this.getUserSub.add(
            this.chatService.UserMe().subscribe({
                next: async (response: IUser) => {
                    this.currentUserStateService.value = response;
                    await this.webSocketService.openSocket((response as any)?.id);
                    await this.webSocketService.waitForConnection();
                    // this.webSocketService.joinRoom(response['id']);
                },
            })
        );
    }

    /**
     * Handle settings button click from header
     * Example of handling the settingsClicked event
     * @param ev Event object
     */
    onSettingsClicked(ev: Event): void {
        // Open the settings menu component
        this.settingsMenuComponent?.showMenu(ev);
    }
}
